import { classed } from "@tw-classed/core";
import type { ReactNode } from "react";

type FormControlProps = {
  children: ReactNode;
  className?: string;
};

export const FormControl = ({ children, className }: FormControlProps) => {
  const classes = classed("form-control");
  return <div className={classes({ className })}>{children}</div>;
};
